// @ts-nocheck: converted from JS

import ColonyCreation from '@/components/Colony/Creation';

export default ColonyCreation;
